import { apiFetch, ApiError } from './client'
import {
  visibilityResponseSchema,
  type VisibilityResponse,
} from '@/lib/schemas/visibility'

/** GET /api/visibility — read-only monitor of product sellable state, server-sorted divergent-first. */
export async function getVisibility(): Promise<VisibilityResponse> {
  const res = await apiFetch('/api/visibility', { method: 'GET' })
  if (!res.ok) {
    const detail = await readDetail(res)
    throw new ApiError(
      res.status,
      detail ?? `Failed to load visibility (${res.status})`,
      detail,
    )
  }
  return visibilityResponseSchema.parse(await res.json())
}

async function readDetail(res: Response): Promise<string | undefined> {
  try {
    const body = (await res.json()) as { detail?: string }
    return body?.detail
  } catch {
    return undefined
  }
}
